<template>
  <transition enter-active-class="fade-in-slide-down" leave-active-class="fade-in-slide-down reverse">
    <dialog class="notice toast" :class="status">
      <div class="notice-content icon-block">
        <svg class="alert-triangle" viewBox="0 0 32 32">
          <!-- eslint-disable-next-line max-len -->
          <path d="M16.1,4c0.7,0,1.3,0.3,1.7,0.9l11.9,18.9c0.6,0.9,0.2,1.7,0.1,2c-0.2,0.3-0.7,1-1.8,1H4.1c-1.1,0-1.6-0.7-1.8-1 c-0.2-0.3-0.5-1.1,0.1-2L14.4,5C14.7,4.4,15.4,4,16.1,4 M16.1,2c-1.3,0-2.6,0.6-3.4,1.9L0.8,22.8C-0.9,25.5,1,29,4.1,29H28 c3.1,0,5.1-3.5,3.4-6.1L19.5,3.9C18.7,2.7,17.4,2,16.1,2L16.1,2z" />
          <rect x="15" y="8" width="2" height="12" />
          <circle cx="16" cy="23.5" r="1.5" />
        </svg>
        <slot></slot>
      </div>
      <button type="button" class="icon flat dark" @click="$emit('close')">
        <svgicon name="close" :alt="closeButtonAlt" />
      </button>
    </dialog>
  </transition>
</template>

<script>
export default {
  props: {
    closeButtonAlt: {
      type: String,
      default: 'close',
    },
    status: {
      type: String,
      default: 'neg',
    },
  },
};
</script>
<style lang="scss" scoped>
dialog {
  position: fixed;
  left: 0.5rem;
  right: 0.5rem;
  top: 0.75rem;
  margin: 0 auto;
  width: calc(100% - 1rem);
  max-width: 40rem;
  z-index: 1000;
  box-shadow: 2px 2px 4px 0 rgba($neutral-900, .2);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  // .close { margin: 1rem 0; }
}
</style>
